import { render, staticRenderFns } from "./SwalAdminEscluso.vue?vue&type=template&id=15a5bd3a&"
import script from "./SwalAdminEscluso.vue?vue&type=script&lang=js&"
export * from "./SwalAdminEscluso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a5bd3a')) {
      api.createRecord('15a5bd3a', component.options)
    } else {
      api.reload('15a5bd3a', component.options)
    }
    module.hot.accept("./SwalAdminEscluso.vue?vue&type=template&id=15a5bd3a&", function () {
      api.rerender('15a5bd3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/swal/SwalAdminEscluso.vue"
export default component.exports